import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'lista-checkbox',
    templateUrl: './lista-checkbox.component.html',
    styles: []
})
export class ListaCheckboxComponent implements OnInit {

    @Input() Nombre: string = "";
    @Input() Placeholder: string = "";
    @Input() OrigenDeDatos: any[] = [];
	@Input() ValorMostrado: string = "";
	@Input() ValorSeleccionado: any[] = [];
    @Input() showSearchBar: boolean = true;
    @Input() disabled: boolean = false;
	@Output() ValorSeleccionadoChange: EventEmitter<any[]> = new EventEmitter();

    public TextoABuscar: string = "";

    constructor() { }

    ngOnInit(): void {
    }

    public Seleccionar(item: any): void {
        this.ValorSeleccionado = item;
        this.ValorSeleccionadoChange.emit(this.ValorSeleccionado);
	}
}